import { ExternalLink } from 'react-feather';
import { useModal } from 'react-modal-hook';
import { useTranslation } from 'react-i18next';

import { GetOrderQuery as GetOrder } from '__generated__/graphql';

import { CopyLinkInput } from '../../../../common/Common/CopyLink';
import UI from '../../../../common/UI';
import useLocale from '../../../../common/useLocale';

type Order = GetOrder['order'];

interface UsePaymentLinkModalProps {
  order: Order;
}

const usePaymentLinkModal = ({ order }: UsePaymentLinkModalProps) => {
  const { formatCurrency } = useLocale();
  const { t } = useTranslation();

  const [openModal, closeModal] = useModal(() => (
    <UI.Modal close={closeModal}>
      <UI.H4 sc={{ mb: 2 }}>
        {t('payment_page')}
      </UI.H4>
      <UI.Paragraph>
        {t('payment_page_description', {
          amount: formatCurrency(order.remaining_amount),
        })}
      </UI.Paragraph>
      <UI.InputGroup>
        <CopyLinkInput value={order.dashboard_url} />
      </UI.InputGroup>
      <UI.A href={order.dashboard_url} target="_blank" rel="noopener noreferrer">
        {t('visit_payment_page')}
        {' '}
        <UI.Icon>
          <ExternalLink />
        </UI.Icon>
      </UI.A>
    </UI.Modal>
  ), [order]);

  return [openModal, closeModal];
};

export default usePaymentLinkModal;
